<template>
    <div :class="`auto-contain auto-contain__${type}`">
        <span class="auto-placeholder" v-if="placeholder">{{placeholder}}<span v-if="required" class="auto-placeholder__required"> *</span></span>
        <v-autocomplete
            :height="height"
            :solo="solo"
            :dense="dense"
            :filled="filled"
            :rounded="rounded"
            :chips="chips"
            :deletable-chips="deletable_chips"
            :multiple="multiple"
            :small-chips="small_chips"
            :value="value"
            :input-value="value"
            @change="$emit('change', $event)"
            @input="$emit('input', $event)"
            :hide-details="hide_details"
            :items="items"
            :clearable="clearable"
            :label="label"
            :rules="rules || []"
            :color="color"
            :item-value="item_value"
            :item-text="item_text"
        ></v-autocomplete>
    </div>
</template>

<script>

export default {
	name: 'UiSelect',
    data: () => ({

    }),
    props:{
        height:{
            type: String,
            required: false
        },
        solo:{
            type: Boolean,
            required: false
        },
        dense:{
            type: Boolean,
            required: false
        },
        filled:{
            type: Boolean,
            required: false
        },
        rounded:{
            type: Boolean,
            required: false
        },
        rules:{
            required: false
        },
        chips:{
            type: Boolean,
            default: false
        },
        deletable_chips:{
            type: Boolean,
            default: false
        },
        multiple:{
            type: Boolean,
            default: false
        },
        small_chips:{
            type: Boolean,
            default: false
        },
        color:{
            type: String,
            default: 'gray'
        },
        hide_details:{
            type: Boolean,
            default: true
        },
        clearable:{
            type: Boolean,
            default: true
        },
        type:{
            default: 'main'
        },
        item_value:{
            default: 'id'
        },
        item_text:{
            default: 'name'
        },
        label:{
            type: String,
            default: false
        },
        hide_details:{
            type: Boolean,
            default: true
        },
        placeholder:{
            type: String,
            default: ''
        },
        items:{
            default: []
        },
        required:{
            default: false
        },
        value:{
            required: true
        }
    },
}
</script>

<style >
    .auto-contain__main {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .auto-contain__placeholder-top {
        text-align: left;
    }
    .auto-contain__placeholder-top .auto-placeholder {
        margin-bottom: 4px;
    }
    .auto-contain__placeholder-top .auto-placeholder__required {
        font-size: 12px;
        color: #e14523;
        margin-left: 4px;
    }
    .auto-contain .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .auto-contain .v-input input {
        font-family: 'Helvetica';
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 148%;
    }
    .auto-contain .auto-placeholder {
        margin-right: 1em;
        font-family: 'Helvetica';
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 148%;
        text-align: right;
        color: #8992b5;
    }
    .ui-input .v-field__field {
        background: white !important;
    }
    @media (max-width: 1650px) {
        .auto-contain .v-input input{
            font-size: 20px;
        }
        .auto-contain .auto-placeholder {
            font-size: 20px;
        }
    }
    @media (max-width: 1350px) {
        .auto-contain .v-input input{
            font-size: 20px;
        }
        .auto-contain .auto-placeholder {
            font-size: 20px;
        }
    }
    @media (max-width: 850px) {
        .auto-contain .v-input input{
            font-size: 14px;
        }
        .auto-contain .auto-placeholder {
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// UiAuto.vue?ae03c404